import * as jsxRuntime from "/home/adrees/sites/orderbeta3.homeappetitphilly.com/subdomains/www/htdocs/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment